import ExportFilterCriteriaSection from "./ExportFilterCriteriaSection";
import { makeStyles } from "@material-ui/core/styles";
import { useEffect, useState } from "react";
import { TextField, Box } from "@material-ui/core";
import "./ExportFilterCriteria.css";
import { useAuthState } from "@bamboobox/b2logincheck";
import { useLocation } from "react-router-dom";
import _ from "lodash";
import { Typography, Autocomplete } from "@mui/material";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { NetNewFilterIcon } from "../../SVGs/netNewFilterIcon";
import { AllAccountsFilterIcon } from "../../SVGs/allAccountsFilterIcon";

import getTenantConfigJSON from "./getTenantConfigJson";

const useStyles = makeStyles({
    customTextField: {
      "& input::placeholder": {
        fontSize: "12px",
        fontFamily: "Inter",
        alignItems: "center",
      },
    },
  });

const relationArrConfig = {
  NUMERIC: ["is equal (=)", "greater than(>)", "less than(<)", "between", "is empty", "is not empty"],
  BOOLEAN: ["true", "false"],
  DATE: ["is equal (=)", "before", "after", "between", "is more than", "in the past", "is empty", "is not empty"],
  TEXT: ["includes", "excludes", "contains", "does not contains", "starts with", "ends with", "is empty", "is not empty"],
  PICKLIST: ["includes", "excludes", "is empty", "is not empty"],
  DEFAULT: ["includes", "excludes", "contains", "does not contains", "starts with", "ends with", "is empty", "is not empty"],
  pastValues: ["1 Day", "Week", "2 Weeks", "Month", "2 Months", "Quarter", "Year"],
};

export const ExportFilterCriteria = (props) => {
  console.log("props inside exportfiltercriteria", props);
  const [subfiltersConfig, setsubfiltersConfig] = useState({});
  const [crmSource, setCRMSource] = useState();
  const [isNetNewEnabled, setIsNetNewEnabled] = useState();
  const [selectedAudience, setSelectedAudience] = useState(
    props.filterAttributesArray[0][0].attribute === "is_net_new"
      ? props.filterAttributesArray[0][0]
      : {
          label: "All Accounts",
          value: "all",
          icon: AllAccountsFilterIcon,
        }
  );

  useEffect(() => {
        const firstAttr = props.filterAttributesArray?.[0]?.[0];
        if (firstAttr?.attribute === "is_net_new") {
            setSelectedAudience(firstAttr);
        }
  }, [props.filterAttributesArray]);

  const TargetAudienceOptions = [
    {
      label: "All Accounts",
      value: "all",
      icon: AllAccountsFilterIcon,
    },
    {
      label: "Target - CRM",
      value: "crm",
      icon: () => <img src={`${window._env_.B2_INTENT_SETTING}/logos/${crmSource ? crmSource?.toString().toLowerCase() : ""}.png`} alt="" style={{ width: "18px" }} />,
    },
    {
      label: "Target - Net New",
      value: "net_new",
      icon: NetNewFilterIcon,
    },
  ];
  const classes = useStyles();
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  let query = useQuery();
  let params_icp = query.get("icp") || "";

  const getFilterAttributesArray = () => {
    if (props.criteriaBody === null) {
      return [[{}]];
    } else {
      return props.criteriaBody;
    }
  };
  const getIsTitleDisabled = () => {
    if (props.criteriaName === undefined) {
      return false;
    } else {
      return true;
    }
  };
  const getTitleValue = () => {
    if (props.criteriaName === null) {
      return null;
    } else {
      return props.criteriaName;
    }
  };
  // useEffect(()=>{
  //     props.setTitle(props.criteriaName)
  // },[props.criteriaName])
  // useEffect(()=>{
  //     props.setFilterAttributesArray(getFilterAttributesArray)
  // },[props.criteriaBody])
  // const [titleDisable, setTitleDisable] = useState(false);
  // const [openDialog, setOpenDialog] = useState(false);
  ////////////////////
  // parent should send the type as prop, now hard coded in ExportFilter component
  // const [exportType, setExportType] = useState("CONTACT");
  // const [exportType, setExportType] = useState(props.exportType || 'CONTACT');
  /////////////////////
  const tenantId = useAuthState().user.tenantId;
  console.log("filterAttributesArray", props.filterAttributesArray);

  useEffect(() => {
    props.setExpType(props.expType || "Contact");
  }, [props.expType]);

  //////////////////////
  //use effect should be edited based on account api
  //////////////////////

  useEffect(() => {
    // console.log("filterAttributesArrayBody->>",filterAttributesArrayBody);
    console.log("props", props.icp);
    let active = true;
    //params_icp
    // let temp_icp = 'capillarytest03june'
    let CDP_API_URL =
      props.expType === "Contact"
        ? `${window._env_.UNIFIED_URL}/contact/new-list/${tenantId}/filter?page=1&limit=10&icp=${params_icp}&sortby=&sortType=`
        : `${window._env_.UNIFIED_URL}/account/new-list/${tenantId}/filter?page=1&limit=10&icp=${params_icp}&sortby=&sortType=`;
    const filterAttributesArrayBody = [];

    console.log("checking props.filterAttributesArray", props.filterAttributesArray);
    if (props.filterAttributesArray?.length > 0) {
      const newFilterAttributesArray = [...props.filterAttributesArray];
      for (const filterAttributes of newFilterAttributesArray) {
        if (filterAttributes.length > 0) {
          const filterAttributesBody = [];
          for (const filterAttribute of filterAttributes) {
            if ("values" in filterAttribute) {
              filterAttributesBody.push(filterAttribute);
            }
          }
          if (filterAttributesBody.length > 0) {
            filterAttributesArrayBody.push(filterAttributesBody);
          }
        }
      }
    }
    console.log("filterAttributesArrayBody");
    console.log("checking filterAttributesArrayBody", filterAttributesArrayBody);

    if (filterAttributesArrayBody.length > 0) {
      console.log("checking2 entering if", filterAttributesArrayBody);

      const requestOptions = {
        credentials: "include",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ filters: filterAttributesArrayBody, columns: [] }),
      };
      const newResultObjects = { ...props.resultObjects };
      console.log(props.resultObjects);
      newResultObjects.contactCount = "-";
      newResultObjects.filter = {};
      if (props.resultObjects !== undefined) {
        console.log("checking res and new - 119", props.resultObjects, newResultObjects);
        props.setResultObjects(newResultObjects);
      }
      fetch(CDP_API_URL, requestOptions)
        .then((result) => result.json())
        .then((jsonResult) => {
          if (jsonResult.success) {
            if (active) {
              if (props.resultObjects !== undefined) {
                console.log("checking res and new - 128", props.resultObjects, newResultObjects);
                props.setResultObjects({
                  totalContactCount: props.resultObjects.totalContactCount,
                  contactCount: jsonResult.filteredCount,
                  filter: { filterBody: filterAttributesArrayBody, filterType: props.expType },
                  title: props.title,
                });
                console.log("checking res and new - 135", props.resultObjects, newResultObjects, filterAttributesArrayBody);
                // props.setResultObjects({ totalContactCount: 346, contactCount: 1, filter: { filterBody: filterAttributesArrayBody, filterType: exportType }, title: title });
              }
            }
            console.log("jsonResult");
            console.log(jsonResult);
          } else {
            console.log(jsonResult);
          }
        });
    } else {
      console.log("checking2 entering else");
      const newResultObjects = { ...props.resultObjects };
      console.log("checking res", props.resultObjects);
      newResultObjects.contactCount = "-";
      newResultObjects.filter = {};
      console.log("checking new", newResultObjects);
      if (props.resultObjects !== undefined) {
        props.setResultObjects(newResultObjects);
      }
    }
    return () => {
      active = false;
    };
  }, [props.filterAttributesArray, props.icp]);

  const getSubfiltersConfig = async () => {
    if (Object.keys(subfiltersConfig).length === 0) {
      const configResp = await getTenantConfigJSON(tenantId, "filters", ["subfiltersConfig"]);

      if (configResp?.length > 0) {
        setsubfiltersConfig(configResp[0]?.configVal);
      }
      return;
    }
  };
  getSubfiltersConfig();

  const textFieldsOnchange = (value) => {
    const newResultObjects = { ...props.resultObjects };
    newResultObjects["title"] = value;
    props.setTitle(value);
    if (props.resultObjects !== undefined) {
      props.setResultObjects(newResultObjects);
    }
  };

  const getCRMSource = async () => {
    if (crmSource) return;
    const requestBody = {
      tenantId: tenantId,
      tool: "CDP",
      keys: ["CRM"],
    };
    fetch(`${window._env_.TENANT_CONFIG}/tenant/get-tenant-config`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
      credentials: "include",
    })
      .then((response) => response.json())
      .then((response) => {
        try {
          if (response[0].configVal) {
            if (response[0].configVal === "ms dynamics") {
              return setCRMSource("dynamics");
            }
            setCRMSource(response[0].configVal);
          }
        } catch (e) {
          console.log(e);
        }
      });
  };

  const checkNetNewEnabled = async () => {
    if (isNetNewEnabled) return;
    const requestBody = {
      tenantId: tenantId,
      tool: "netNewHub",
      keys: ["isEnabled"],
    };
    const response = await fetch(`${window._env_.TENANT_CONFIG}/tenant/get-tenant-config`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
      credentials: "include",
    });
    const result = await response.json();
    if (result.length > 0) {
      if (result[0].configVal === "true" || result[0].configVal === true) {
        return setIsNetNewEnabled(true);
      } else return setIsNetNewEnabled(false);
    }
  }

  useEffect(() => {
    checkNetNewEnabled();
    getCRMSource();
  }, []);

  const onAudienceChange = (attrData, isDelete) => {
    const newFilterAttributesArray = props.filterAttributesArray.map((element, index) => {
      const newElement = element.filter((ele) => ele.attribute !== "is_net_new");
      return isDelete ? [...newElement] : [attrData, ...newElement];
    });
    props.setFilterAttributesArray(newFilterAttributesArray);
  };

  return (
    <div id="export-filter-criteria">
      <div id="scroll">
        {(isNetNewEnabled || props.new_new_permission) && (
          <>
          <Typography
            variant="subtitle2"
            className="and-button1"
            style={{
              width: "180px",
              height: "24px",
              fontStyle: "normal",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "100%",
              alignItems: "center",
              letterSpacing: "0.15px",
              textTransform: "none",
              color: "#424242",
              margin: "10px 0 -15px 0",
            }}
          >
            Target Audience
          </Typography>
          <Autocomplete
            sx={{ width: "330px", marginBottom: "20px" }}
            options={TargetAudienceOptions}
            getOptionLabel={(option) => (option?.values?.[0] === true || option.value ==="net_new" ? 'Target - Net New' : option?.values?.[0] === false || option.value === 'crm' ? 'Target - CRM' : 'All Accounts')}
            // open
            value={selectedAudience}
            onChange={(e, newValue) => {
              const netNewFilterObj = {
                attribute: "is_net_new",
                relation: "is",
                type: "accounts",
                values: [newValue.value === "net_new"],
              };
              if (newValue.value === "net_new" || newValue.value === "crm") {
                onAudienceChange(netNewFilterObj);
              } else if (props.filterAttributesArray[0][0].attribute === "is_net_new") {
                onAudienceChange(netNewFilterObj, true);
              }
              setSelectedAudience(newValue);
            }}
            disableClearable
            popupIcon={<KeyboardArrowDownRoundedIcon />}
            renderOption={(props, option) => {
              const Icon = option.icon;
              return (
                <li {...props}>
                  <Box display="flex" alignItems="center" fontSize="12px" fontWeight={500} color="#424242" fontFamily={"Inter"}>
                    <Icon />
                    <Box ml={1}>{option.label}</Box>
                  </Box>
                </li>
              );
            }}
            renderInput={(params, p2) => {
              const index = params.inputProps.value === "Target - CRM" ? 1 : params.inputProps.value === "Target - Net New" ? 2 : 0;
              const SelectedIcon = TargetAudienceOptions[index].icon;
              return (
                <TextField
                  {...params}
                  placeholder="Select Audience"
                  classes={{ root: classes.customTextField }}
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: SelectedIcon ? <span style={{ marginRight: "10px" }}><SelectedIcon /></span> : null,
                    sx: {
                      input: {
                        fontWeight: 500,
                        fontSize: "12px",
                        color: "#424242",
                        height: "5px",
                      },
                    },
                  }}
                />
              );
            }}
          />
        </>
        )}
        {props.filterAttributesArray?.map((filterAttributes, filterAttributesIndex) => (
          <ExportFilterCriteriaSection
            key={`filterAttributes${filterAttributesIndex}`}
            filterAttributesArray={props.filterAttributesArray}
            filterAttributesIndex={filterAttributesIndex}
            filterAttributes={filterAttributes}
            setFilterAttributesArray={props.setFilterAttributesArray}
            icp={props.icp}
            exportType={props.expType}
            relationArrConfig={relationArrConfig}
            subfiltersConfig={subfiltersConfig}
          />
        ))}
      </div>
    </div>
  );
};

export default ExportFilterCriteria;
